<script>
import { mapMutations, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['showTerms', 'showPrivacy']),
    ...mapState('property', {
      property: (state) => state.currentProperty,
    }),
  },
  methods: {
    ...mapMutations('app', {
      toggleTerms: 'TOGGLE_TERMS',
      togglePrivacy: 'TOGGLE_PRIVACY',
    }),
  },
}
</script>

<template>
  <div>
    <BaseModal
      :value="showTerms"
      title="Terms of Use"
      size="3xl"
      @input="toggleTerms"
    >
      <!-- eslint-disable-next-line -->
      <p v-html="property.policy.termsAndConditions"></p>
    </BaseModal>
    <BaseModal
      :value="showPrivacy"
      title="Privacy Policy"
      size="3xl"
      @input="togglePrivacy"
    >
      <!-- eslint-disable-next-line -->
      <p v-html="property.policy.privacy"></p>
    </BaseModal>
  </div>
</template>
